<template>
	<PostGallery v-model:visible="displayBasic" v-model:activeIndex="activeIndex" :value="ImageGallery"
		containerStyle="max-width: 59%" circular fullScreen :showThumbnails="false" :showItemNavigators="true"
		@update:activeIndex="handleActiveIndexChange">
		<template #header>
			<div class="text-mb mx-auto px-2 mb-3 font-bold text-white">
				{{ ImageGallery?.[activeIndex]?.imageTitle }}
			</div>
		</template>

		<template #item="slotProps">
			<img class="mx-auto max-h-[720px]" :src="slotProps.item.imageSrc" :alt="slotProps.item.imageTitle" />
		</template>
		<template #footer>
			<p class="text-white text-right ml-auto px-2 mt-3 text-xs"> {{ ImageGallery?.[activeIndex]?.imageCopyright
				}} </p>
			<p class="text-white mx-auto px-2 mt-3">{{ ImageGallery?.[activeIndex]?.imageDescription }}</p>
		</template>
	</PostGallery>

	<div v-for="(item, activeIndex) in props.jsonData.illustration" :key="activeIndex" class="border p-3 mb-3 relative">
		<EditButton
			v-if="props.collectionModeData?.editmode && props.jsonData.illustration?.[activeIndex]?.imageSrcEdit"
			class="absolute right-[0] top-[0] rounded bg-danger rounded hover:bg-danger-200 items-center p-2 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all !text-white"
			:id="props.jsonData.identifier ?? ''"
			:type=" collectionModeData?.id != 'language_review' ? 'imageattr' : 'lngReviewEdit'"
			:overrideURL="props.jsonData.illustration?.[activeIndex]?.imageSrcEdit" />

		<div class="text-sm font-semibold mb-3">
			{{ item.imageTitle }}
		</div>
		<div class="mb-3 relative">
			<img :src="item.imageSrc"
				class="img-thumbnail w-220px md:w-auto mx-auto text-center overflow-hidden md:h-100% cursor-pointer max-h-[720px]"
				alt="preview" @click="openGallery(activeIndex)" />
			<div class="text-sm pt-2">
				<p class="text-right ml-auto mb-2 text-xs">{{ item.imageCopyright }}</p>

				{{ item.imageDescription }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';
import EditButton from '../components/EditButton.vue';
import type { configCollectionMode } from '@/types'


const props = defineProps<{
	jsonData: {
		identifier?: string;
		illustration?: {
			imageTitle?: string;
			imageSrc?: string;
			imageSrcEdit?: string
			imageCopyright?: string;
			imageDescription?: string;
		}[];
		_links: {
			illustration: {
				href: string;
			};
		};
	};
	collectionModeData?: configCollectionMode | null;
}>();

const displayBasic = ref(false);
const activeIndex = ref(0);
const ImageGallery = ref(props.jsonData.illustration);

function handleActiveIndexChange(newIndex: number) {
	activeIndex.value = newIndex;
	nextTick(() => {
		console.log('Active Index updated:', activeIndex.value);
	});
}
function openGallery(index: number) {
	activeIndex.value = index;
	displayBasic.value = true;
}
</script>
<style>
button.p-image-preview-indicator:before {
	content: '';
	background: #000;
	position: absolute;
	left: 0;
	bottom: 0;
	right: 0;
	top: 0;
	height: 100%;
	width: 100%;
	opacity: 0.5;
	z-index: 0;
}
button.p-image-preview-indicator svg {
	z-index: 2;
	fill: white;
}
button.p-image-preview-indicator svg path {
	fill: white;
}
.p-image-toolbar {
	background: #000;
}
.p-galleria-mask path {
	fill: white !important;
}
button.p-galleria-item-nav.p-link {
	z-index: 2;
}
.p-galleria-caption {
	padding-top: 10px;
	padding-bottom: 10px;
}
.p-galleria-mask .p-galleria {
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	overflow-y:auto;
}
/* SLIMSCROLL STYLE – identical to SmartAdmin 4.5 */
.p-galleria-mask .p-galleria::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.p-galleria-mask .p-galleria::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
}

.p-galleria-mask .p-galleria::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    transition: background 0.3s ease;
}

.p-galleria-mask .p-galleria::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.45);
}

/* Optional – improve appearance in Firefox */
.p-galleria-mask .p-galleria {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.p-galleria-item-wrapper {
	flex: 1;
	min-height: 0; /* fix që lejon scroll */
}

</style>
